import React, { useState } from 'react';
import Header from './components/Header';
import BentoBoxes from './components/BentoBoxes';
import TabsSection from './components/TabsSection';
import TokenTable from './components/TokenTable';
import './App.css';

function App() {
  const [activeTab, setActiveTab] = useState('Live');

  return (
    <div className="App">
      <Header />
      <BentoBoxes />
      <TabsSection activeTab={activeTab} setActiveTab={setActiveTab} />
      <TokenTable activeTab={activeTab} />
    </div>
  );
}

export default App;
